import {OrderScooberJob} from '~/shared/store/models';

import {makeAsyncReducer, StateAsyncProperty} from '../../redux-toolbelt';

import {getUserLastOrderScooberJob} from './userLastOrderScooberJobActions';

type UserLastOrderScooberJobState = StateAsyncProperty<OrderScooberJob>;

export default makeAsyncReducer<UserLastOrderScooberJobState>(
  getUserLastOrderScooberJob,
  {shouldDestroyData: false},
);
